import type { ReceiptTemplate } from '../schema';

export const tjMaxxTemplate: ReceiptTemplate = {
  id: 'tj-maxx',
  name: 'TJ Maxx Receipt',
  brand: 'T.J. MAXX',
  description: 'TJ Maxx discount store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'tjm-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/tj-maxx.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tjm-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tjm-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'DESIGNER HANDBAG', quantity: '1', price: '59.99', sku: '847291034' },
          { id: '2', name: 'MENS DRESS SHIRT', quantity: '1', price: '19.99', sku: '847291035' },
          { id: '3', name: 'HOME FRAGRANCE', quantity: '1', price: '12.99', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tjm-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '92.97', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '7.67', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '100.64', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'tjm-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'TJX REWARDS ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'tjm-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'MAXX LIFE\n\nReturns within 30 days\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

